// extracted by mini-css-extract-plugin
export default {"loader":"loader--rbYh4","absolute":"absolute--AiLNj","fixed":"fixed--vQMgK","spinner":"spinner--XRAc3","rotate":"rotate--_lSvG","blink":"blink--f2uQL"};